export const mediaTypes = {
  IMAGE_S3: 'IMAGE_S3',
  IMAGE_URL: 'IMAGE_URL',
  VIDEO_S3: 'VIDEO_S3',
  VIDEO_URL: 'VIDEO_URL',
};

export const scrollSize = 298;
